import { useEffect } from "react";
import { createPortal } from "react-dom";
import Backdrop from "../../components/common/Backdrop"; 
export default function Modal({ isOpen, onClose, children, maxWidth = "max-w-md" }) {

    useEffect(() => {
        const handler = (e) => { if (e.key === "Escape") onClose(); };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [onClose]);

    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 z-[999] flex items-center justify-center px-4" aria-modal="true" role="dialog">

            <Backdrop isOpen={isOpen} onClose={onClose} />

            {/* Modal Box */}
            <div className={`relative w-full ${maxWidth} bg-white rounded-2xl shadow-2xl z-10 animate-modal`}>
                <button
                    onClick={onClose}
                    className="cursor-pointer absolute top-1 right-1 md:top-4 md:right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-black transition-all text-lg leading-none"
                    aria-label="Close"
                >
                    ✕
                </button>
                {children}
            </div>

            <style>{`
                @keyframes modalIn {
                    from { opacity: 0; transform: translateY(20px) scale(0.97); }
                    to   { opacity: 1; transform: translateY(0) scale(1); }
                }
                .animate-modal { animation: modalIn 0.22s ease forwards; }
            `}</style>
        </div>,
        document.body
    );
}